<template>
  <div class="distribution-settings">
    <b-tabs>
      <b-tab
        title="General"
        :active="routeName === 'distribution-general'"
        @click="changeView('distribution-general')"
      />
      <b-tab
        title="Origins and Origin Groups"
        :active="routeName === 'distribution-origins'"
        @click="changeView('distribution-origins')"
      />
      <b-tab
        title="Behaviors"
        :active="routeName === 'distribution-behaviors'"
        @click="changeView('distribution-behaviors')"
      />
      <b-tab
        title="Error Pages"
        :active="routeName === 'distribution-error-pages'"
        @click="changeView('distribution-error-pages')"
      />
      <b-tab
        title="Restrictions"
        :active="routeName === 'distribution-restrictions'"
        @click="changeView('distribution-restrictions')"
      />
      <b-tab
        title="Invalidations"
        :active="routeName === 'distribution-invalidations'"
        @click="changeView('distribution-invalidations')"
      />
      <b-tab
        title="Tags"
        :active="routeName === 'distribution-tags'"
        @click="changeView('distribution-tags')"
      />
    </b-tabs>
    <transition
      name="fade"
      mode="out-in"
    >
      <parent>
        <router-view :key="$route.path" />
      </parent>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'DistributionView',
  computed: {
    routeName() {
      return this.$route.name
    },
  },
  methods: {
    changeView(view) {
      this.$router.push({ name: view }).catch(() => {})
    },
  },
}
</script>
